import React from 'react'

import type { IdType } from 'EditorApp/types'

interface Props {
  name: string
  id: IdType
  svg: string
}

const RenderedSvgElement = ({ name, id, svg }: Props) => {
  return (
    <div className={name} data-element-id={id}>
      <div
        className={`${name}__container`}
        dangerouslySetInnerHTML={{ __html: svg }}
      />
    </div>
  )
}

export default RenderedSvgElement
